import { Incident } from "../types/types"
import incidentsResponse from "../data/incidents.json"

const useIncidents = () => {
  return (incidentsResponse.incidents as unknown) as Incident[]
}

export default useIncidents
